<div class="background-container">
  <div class="outer-container">
    @if (site) {
      @if (!isAdmin) {
        <div class="page-heading-container">
          <div class="page-name-row">Disturbance Reporting</div>
          <mat-divider></mat-divider>
          @if (!readOnly) {
            <div class="page-description">
              Please take a moment to fill out the questions to keep us informed on the status of your Carbon Offset
              Site.
              Some answers may require some additional description.
            </div>
          }
        </div>
      } @else {
        <div [ngStyle]="{ 'flex-direction': 'row', 'align-items': 'center' }" class="page-heading-container">
          <div class="page-name-row">Disturbance Reporting</div>
          <div class="page-status-row">
            <span>Status:</span>
            {{ site.status }}
          </div>
        </div>
        <mat-divider></mat-divider>
      }
      <div class="inner-container">
        <div class="site-name">{{ site.name }}</div>
        <mat-divider></mat-divider>
        <div class="site-overview">
          <div class="overview-title">Site Overview</div>
          <div class="overview-data">
            <div class="site-name">
              Site Name:
              <span>{{ site.name }}</span>
            </div>
            <div>
              Applicant:
              <span>{{ getApplicantName() }}</span>
              <span class="user-verified">
                {{ isApplicantVerified() ? '✓' : '' }}
              </span>
            </div>
            <div>
              Submitted Date:
              <span>{{ site.submittedDate | date: 'shortDate' }}</span>
            </div>
            <div>
              Parcel Number:
              <span>{{ parcelCommaSeparatedList }}</span>
            </div>
            <div>
              Forested Acres:
              <span>{{ getArea() }}</span>
            </div>
            <div>
              Stands:
              <span>{{ getStandCount() }}</span>
            </div>
            <div>
              Site #:
              <span>{{ site.id }}</span>
            </div>
            <div>
              Enrollment Group:
              <span>{{ site.enrollmentGroup.name }}</span>
            </div>
            <div class="projected-payment">
              <div class="payment-label">Estimated Annual Revenue:</div>
              <span>{{ projectedNext12MonthRevenue }}</span>
              <fa-icon
                #tooltip="matTooltip"
                (click)="tooltip.toggle()"
                [icon]="['far', 'circle-info']"
                class="blue"
                [matTooltip]="site.getAnnualRevenueIconText()"
                matTooltipClass="fc-tooltip"
                matTooltipPosition="right"></fa-icon>
            </div>
          </div>
        </div>
        <mat-divider></mat-divider>
        <div class="full-form" [ngClass]="readOnly ? 'readonly' : ''">
          <form [formGroup]="reportForm" fcFormUnloadWarning>
            <div class="question-list">
              <div>1.</div>
              <div class="question-section">
                <div>How would you describe the disturbance on this land?</div>
                <mat-form-field>
                  <mat-select [disabled]="readOnly" formControlName="disturbanceType" placeholder="Select One">
                    @for (group of disturbanceCauses; track group) {
                      <mat-option [value]="group.name">
                        {{ group.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div>2.</div>
              <div class="question-section">
                <div>Select the cause of this disturbance:</div>
                <mat-form-field>
                  <mat-select [disabled]="readOnly" formControlName="cause" placeholder="Select One">
                    @for (group of disturbanceCauses; track group) {
                      <mat-optgroup [label]="group.name">
                        @for (cause of group.cause; track cause) {
                          <mat-option [value]="cause.value">
                            {{ cause.viewValue }}
                          </mat-option>
                        }
                      </mat-optgroup>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div>3.</div>
              <div class="question-section">
                <div>What was the approximate percentage of the Forest that was impacted by this disturbance?</div>
                <mat-form-field>
                  <mat-select [disabled]="readOnly" formControlName="impactPercentage" placeholder="Select One">
                    @for (percentage of impactPercentages; track percentage) {
                      <mat-option [value]="percentage.value">
                        {{ percentage.viewValue }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div>4.</div>
              <div class="question-section">
                <div>In your own words, please provide us with a general description of the disturbance:</div>
                <textarea formControlName="description" rows="4"></textarea>
              </div>
              <div>&nbsp;</div>
              @if (!readOnly) {
                <div class="question-section">
                  <mat-checkbox class="legalAck" id="legalAck" data-cy="legal-ack" formControlName="legalAck">
                    {{ LegalConstants.QUESTION_DISCLAIMER }}
                  </mat-checkbox>
                </div>
              }
              <div>&nbsp;</div>
              @if (!readOnly) {
                <div class="question-section buttons">
                  <button
                    (click)="submitReport()"
                    [disabled]="!reportForm.valid"
                    class="submit-button"
                    color="primary"
                    data-cy="submit-disturbance-report-button"
                    mat-raised-button>
                    Submit Report
                  </button>
                </div>
              }
            </div>
          </form>
        </div>
      </div>
    }
  </div>
</div>
